<template>
  <div class="page-lock">
    <div class="page-lock__image">
      <responsive-image
        :image="{src: image}"
        min-max="312-768"
        sizes="100vw"
        ratio="4:3"
      />
    </div>

    <div class="page-lock__info">
      <h2
        class="h3 page-lock__header"
        v-text="fullTitle"
      />

      <p
        v-if="content"
        class="page-lock__content body-2"
        v-text="content"
      />

      <form
        class="page-lock__form"
        @submit.prevent="onSubmit"
      >
        <label
          class="caption"
          for="email"
          v-text="$string('password_page.access')"
        />

        <input
          id="access_code"
          v-model="submission"
          type="text"
          name="access_code"
          :placeholder="$string('password_page.placeholder')"
        >

        <span
          v-if="error"
          class="page-lock__error caption"
          v-text="$string('password_page.error')"
        />

        <btn
          :show-icon="false"
          class="page-lock__button"
          :label="$string('password_page.submit')"
          modifiers="boxed"
        />
      </form>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Page lock (page-lock)
 * -----------------------------------------------------------------------------
 * Password Lock a page.
 * @param {String} password - Password to unlock page
 * @param {String} title - Page title
 * @param {String} subTitle - Page subtitle
 * @param {String} content - Page content
 * @param {String} image - Featured image URL
 */
export default {
  name: 'PageLock',

  props: {
    password: {
      type: [Boolean, String],
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
  },

  emits: ['page-unlocked'],

  data() {
    return {
      error: false,
      submission: '',
    }
  },

  computed: {

    /**
     * Compute full title.
     * @returns {String}
     */
    fullTitle() {
      return `${this.title} ${this.subTitle}`
    },
  },

  mounted() {
    document.querySelector('body').classList.add('page-locked')
  },

  methods: {

    /**
     * Listen for form submission, store url in localStorage is password matches
     */
    onSubmit() {
      if (
        !this.submission ||
        this.submission.toLowerCase() !== this.password.toLowerCase()
      ) {
        this.error = true
        return
      }

      this.error = false
      const unlocked = JSON.parse(localStorage.getItem('unlockedPages'))

      if (Array.isArray(unlocked)) {
        if (unlocked.includes(window.location.pathname)) {
          return
        }

        unlocked.push(window.location.pathname)
        localStorage.setItem('unlockedPages', JSON.stringify(unlocked))
      } else {
        localStorage.setItem('unlockedPages', `[${JSON.stringify(window.location.pathname)}]`)
      }

      this.$emit('page-unlocked')
      document.querySelector('body').classList.remove('page-locked')
    },
  },
}
</script>

<style lang="scss">
@import './page-lock';
</style>
